import { useEffect, useState } from 'react';
import { AppStoreButtons } from '@molecules/index';
import { resolveMobileAppStoreUrl } from '../constants/mobileAppLinks';

const AppDownloadPage = () => {
  const [isRedirecting, setIsRedirecting] = useState(true);

  useEffect(() => {
    const storeUrl = resolveMobileAppStoreUrl();

    if (!storeUrl) {
      setIsRedirecting(false);
      return;
    }

    window.location.assign(storeUrl);

    const fallbackTimer = window.setTimeout(() => {
      setIsRedirecting(false);
    }, 2500);

    return () => window.clearTimeout(fallbackTimer);
  }, []);

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center p-6">
      <div className="bg-gray-900 rounded-3xl p-8 max-w-md w-full text-center">
        <div className="w-16 h-16 rounded-2xl overflow-hidden shadow-lg mx-auto mb-6">
          <img
            src="/favicon/android-chrome-192x192.png"
            alt="Lezzet Yolda Logo"
            className="w-full h-full object-contain"
          />
        </div>

        <h1 className="text-white text-2xl font-bold mb-2">Lezzet Yolda Mobil Uygulaması</h1>
        <p className="text-gray-400 mb-8">
          {isRedirecting
            ? 'Uygulama mağazasına yönlendiriliyorsunuz...'
            : 'Mobil uygulamayı indirmek için mağaza bağlantısını seçin.'}
        </p>

        <AppStoreButtons />
      </div>
    </div>
  );
};

export default AppDownloadPage;
